'use client';

import { useAppContext } from 'context/state';
import { useUserContext } from 'context/user_state';

import { FC, useEffect } from 'react';

import HeadPhonesSvg from 'components/svg/HeadPhonesSvg';
import IconButton from 'components/ui/IconButtonV2';
import initMaia from './maia-chat';

const CHAT_BUTTON_ID = 'chat-bubble';

const Maia: FC = () => {
  const userContext = useUserContext();
  const appContext = useAppContext();

  useEffect(() => {
    if (appContext.isMaiaInit) return;

    initMaia(
      CHAT_BUTTON_ID,
      true,
      process.env.MAIA_APP_ID,
      process.env.MAIA_API_HASH,
      userContext?.currentProfile?.id,
    );
    appContext.setIsMaiaInit(true);
  }, []);

  return <IconButton id={CHAT_BUTTON_ID} icon={<HeadPhonesSvg />} />;
};

export default Maia;
